import Backbone from 'backbone';

var Question = Backbone.Model.extend({

    initialize: function() {
        if (this.get('choices')) {
            this.set('choices', new Backbone.Collection(this.get('choices')));
        }
    }


});

export default Question;

